import { useSessionStore } from '@/stores/sessionStore'

const PROBE_TIMEOUT_MS = 5_000

/**
 * Does the backend answer at all? Resolves true on ANY HTTP response (a
 * 401 is still an answer), false on a network-level failure or timeout.
 * Never rejects. connectionHealthStore runs it while the browser claims
 * offline, to tell a real outage from a stale navigator.onLine.
 *
 * Same request as the /connect page probe, minus what reachability
 * doesn't need: `no-cors` so a missing CORS header can't read as offline,
 * `credentials: 'omit'` so a Basic-auth-gated staging host can't pop
 * Chrome's sign-in dialog, `no-store` so a cached response can't vouch for
 * a dead network. With no backend chosen yet (/connect), the POS's own
 * origin answers instead -- that still proves the network is up.
 */
export async function probeBackendReachable(): Promise<boolean> {
  const base = useSessionStore.getState().backendUrl || ''
  try {
    await fetch(`${base}/ht/api/status`, {
      mode: 'no-cors',
      credentials: 'omit',
      cache: 'no-store',
      signal: AbortSignal.timeout(PROBE_TIMEOUT_MS),
    })
    return true
  } catch {
    return false
  }
}
